const PictureActionTypes = {
    FETCH_PICTURES_START: 'FETCH_PICTURES_START',
    FETCH_PICTURES_SUCCESS: 'FETCH_PICTURES_SUCCESS',
    FETCH_PICTURES_FAILURE: 'FETCH_PICTURES_FAILURE'
};

export default PictureActionTypes;
